import { render, staticRenderFns } from "./AcordFormList.vue?vue&type=template&id=cdacdf2a&scoped=true&"
import script from "./AcordFormList.vue?vue&type=script&lang=ts&"
export * from "./AcordFormList.vue?vue&type=script&lang=ts&"
import style0 from "./AcordFormList.vue?vue&type=style&index=0&id=cdacdf2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdacdf2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VTooltip})
